//import logo from './logo.svg';
//import './App.css';
import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {Version, logVersion} from "./components/version"
import mapboxgl from 'mapbox-gl';
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import './css/index.css';
import './css/mapbox-gl-draw.css';
//import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import * as d3 from "d3";
import * as qs from 'query-string';
import {useSpring, animated} from 'react-spring';

import ReactDatGui from './components/ReactDatGui';
import BasicLayer from './components/basicLayer';
import Bunkers from './components/Bunkers';
import TimeSlider from './components/Slider';
import D3Comp from './components/D3Comp';
import Story from './components/Story';
import Sidebars from './components/Sidebars';
import Draw from './components/Draw';
import BarChart from './components/BarChart';
import LegendAndControl from './components/LegendAndControl';

//import {CustomIcons} from './components/customIcons';

//import mySVG from './logo.svg';
import mySVG from './images/bunker4a.svg';
import mySVG2 from './images/bunker4.svg';

//import functions from './helpers'; // then functions.toUnique

import SatSlider from "./components/SatSlider";

import {useStore} from './components/store';
import {getObjectDiff, t} from './helpers';
//import Trans from './components/Trans';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

// hot-fix bug: no reference m in console; reason: ES6 incompatibility in current mapbox-gl version
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			map: {},
			lng: 11.5,
			lat: 46.6,
			zoom: 8.3,
			pitch: 0,
			bearing: 0,
			lang: 'DE',
			firstFetch: false,
			limitExceeded: null,
			mapLoaded: false,
			editorAuthorized: false,
			bunkerLoaded: false,
			SVGLoaded: false,
			allLoaded: false,
			hideSplash: false,
			hideMapinfo: true,
			currRecord: null,
			currData: null,
			guiData: null,
			init: null,
			initDraw: false,
			storyOn: true,
			startQuickTour: false,
			activateSidebars: false,
			sidebarsContent: ["xyz"],
			sidebarsAction: "none",
			storyRemoteAction: "none",
			story: null,
			sidebars: null,
			showTimeline: true,
			showLegend: true,
			debugLevel: 0
		};
		this.map = null;
		this.Draw = null;
	}



	callbackData = (formData) => {
		this.setState({guiData: formData})
	};

	callbackDataButton = (formData) => {
		this.setState({lastGuiButton: formData})
	};

	// abstracted handler to set obj
	callbackHandler = (obj) => {
		this.setState(obj)
	}

	callbackStoryHandler = (obj) => {

		if (obj.storyData) {
			if (!obj.storyData.direction?.action) {
				this.setState({story: obj});
				return
			}
			switch (obj.storyData.direction.action) {
				case "showContent":
					let newstate = {...this.state};
					newstate.story = obj;
					newstate.sidebarsAction = "open left";
					newstate.sidebarsContent = obj.storyData.direction.content;
					this.setState(newstate);
					break;
				case "move":
					this.setState({story: obj, sidebarsAction: "close both"});
					break;
				default:
					this.setState({story: obj});
					break;
			}
		}
	};

	callbackRemoteStoryHandler = (obj) => {
		this.setState(obj);
	}

	callbackSidebarsHandler = (d) => {
		this.setState(d)
	};

	callbackLegendHandler = (d) => {
		this.setState({lastGuiButton: d })
	};

	callbackLegendProgressHandler = (d) => {
		this.setState({showTimeline: d })
	};


	callbackSatSlider = (d) => {
		var guiData = {...this.state.guiData};
		guiData.toggleSatellite= d > 0 ? true : false;
		guiData.opacitySatellite= d/100;
		this.setState({
			guiData
		});
	}

	callbackLang = (d) => {
		this.setState({lang: d })
	}


	callbackStoryRemote = (d) => {

		// console.log("########## current action", d);

		if (d === "next") {
			this.setState({storyRemoteAction: "next"});
			const next = useStore.getState().setRemoteAction('next')
		} else if (d === "shootingRange") {
			this.map.setLayoutProperty('bunker-radius', 'visibility', this.state.guiData.toggleBunkersRadius ? 'none' : 'visible');
			let newstate = {...this.state};
			newstate.guiData.toggleBunkersRadius = this.state.guiData.toggleBunkersRadius ? false : true;
			this.setState(newstate);
		} else if (d === "end") {
			useStore.getState().setRemoteAction('ending')
			this.setState({storyRemoteAction:"none"})
			setTimeout(()=>{
				if (useStore.getState().remoteAction !== 'end') {
					// console.log('###********', this.map)
					useStore.getState().setRemoteAction('end')
				}
			},5000 )
		}
	}


	loadData(id) {

		let myurl = process.env.REACT_APP_PUBLIC_PATH + '/api/rest/cachedbunkers';
		fetch(myurl, {
			method: 'GET',
			headers: {
				'X-API-KEY': process.env.REACT_APP_API_KEY,
//				'Content-Type': 'application/x-www-form-urlencoded',
				'Accept': 'application/json'
			}
		})
			.then(response => {
				return response.json();
			})
			.then(result => {
				this.setState((currRecord, currData) => ({
					currData: result
				}));
			});
		return;
	}


	async getAuth(token) {
		// send key to REST-API making an authorization request, get editor token if successful
		let myurl = process.env.REACT_APP_PUBLIC_PATH + '/api/rest/check/editortoken/' + token;
		fetch(myurl, {
			method: 'GET',
			headers: {
				'X-API-KEY': process.env.REACT_APP_API_KEY,
				'Accept': 'application/json'
			}
		})
			.then(response => {
//				console.log(response);
				return response.ok ? response.json() : null;
			})
			.then(result => {
				this.setState({
					editorKey: result ? result : null,
					editorAuthorized: !!result
				});
			});
	}

	async loadSVG(name, svg, width = 15, height = 15) {
//      console.log("SVG: ====> ", name, svg, width, height);
		let img = new Image(width, height);
		img.onload = () => this.map.addImage(name, img);
		img.src = svg;
	}

	toggleLayers = (LayerName, currState) => {
		const getS = (key) => this.state.guiData[key];
		// console.log("toggle layers", LayerName, getS(currState));
		this.map.setLayoutProperty(LayerName, 'visibility', getS(currState) ? 'visible' : 'none');
	}

	toggleLayersD3 = (currState) => {
		const getS = (key) => this.state.guiData[key];
		//console.log("D3 visibility change", getS(currState));
		d3.selectAll(".bunkerSVGs").style("visibility", getS(currState) ? 'visible' : 'hidden')
		d3.selectAll(".button").style("visibility", 'visible');
	}

	setAllGuiData = (prevState) => {

		let changedArr = getObjectDiff(this.state.guiData, prevState);

		changedArr.forEach((change) => {

			switch (change) {
				case "animationSpeed":
//					console.log('animation speed updated');
					break;
				case "toggleColors_built":
					useStore.getState().setColors_built(this.state.guiData.toggleColors_built);
					break;
				case "toggleColors_notbuilt":
					useStore.getState().setColors_notbuilt(this.state.guiData.toggleColors_notbuilt);
					break;
				case "toggleColor0":
					useStore.getState().setColors0(this.state.guiData.toggleColor0);
					break;
				case "toggleColors1":
					useStore.getState().setColors1(this.state.guiData.toggleColors1);
					break;
				case "toggleColors2":
					useStore.getState().setColors2(this.state.guiData.toggleColors2);
					break;
				case "toggleColors3":
					useStore.getState().setColors3(this.state.guiData.toggleColors3);
					break;
				case "toggleStroke_desc":
					useStore.getState().setStroke_desc(this.state.guiData.toggleStroke_desc);
					break;
				case "toggleStroke_sel":
					useStore.getState().setStroke_sel(this.state.guiData.toggleStroke_sel);
					break;

				case "toggleStroke_built":
					useStore.getState().setStroke_built(this.state.guiData.toggleStroke_built);
					break;
				case "toggleStroke_notbuilt":
					useStore.getState().setStroke_notbuilt(this.state.guiData.toggleStroke_notbuilt);
					break;
				case "toggleStroke0":
					useStore.getState().setStroke0(this.state.guiData.toggleStroke0);
					break;
				case "toggleStroke1":
					useStore.getState().setStroke1(this.state.guiData.toggleStroke1);
					break;
				case "toggleStroke2":
					useStore.getState().setStroke2(this.state.guiData.toggleStroke2);
					break;
				case "toggleStroke3":
					useStore.getState().setStroke3(this.state.guiData.toggleStroke3);
					break;

				case "toggleMapinfo":
					this.setState({hideMapinfo: this.state.hideMapinfo ? false : true});
					break;
				case "toggleLabel":
					this.toggleLayers("bunker-label", "toggleLabel");
					break;
				case "toggleBunkers":
					this.toggleLayers("bunker-icons", "toggleBunkers");
					break;
				case "toggleBunkersPoly":
					this.toggleLayers("bunker-poly", "toggleBunkersPoly");
					break;
				case "toggleBunkersSVG":
					this.toggleLayers("bunker-SVG", "toggleBunkersSVG");
					break;
				case "toggleBunkersDynamic":
					if (this.state.guiData.toggleBunkersDynamic === false) {
						this.setState({bunkerDynamic: false})
					} else {
						var guiData = {...this.state.guiData};
						guiData.toggleBunkersD3 = false;
						guiData.toggleBunkersSVG = true;
						guiData.toggleBunkersPoly = false;
						guiData.randomUpdate = Math.random(); // ! important ! to signal that app updates datGUI
						this.setState({
							bunkerDynamic: true,
							guiData
						});
					}
					break;
				case "toggleBunkersD3":
					this.toggleLayersD3("toggleBunkersD3");
					break;
				case "toggleBunkersRadius":
					this.toggleLayers("bunker-radius", "toggleBunkersRadius");
					break;
				case "toggleBunkersRadiusUnion":
					this.toggleLayers("bunker-radius-merged", "toggleBunkersRadiusUnion");
					break;
				case "toggleBunkersSVGvariants":
					this.toggleLayers("bunker-SVG2", "toggleBunkersSVGvariants");
					break;
				case "toggleBunkersCircle":
					this.toggleLayers("bunker-circle", "toggleBunkersCircle");
					break;
				case "toggleBunkersCircleAll":
					this.toggleLayers("bunker-circle-all", "toggleBunkersCircleAll");
					break;
				case "toggleContour":
					this.toggleLayers("contour-line", "toggleContour");
					break;
				case "toggleSatellite":
					this.toggleLayers("satellite", "toggleSatellite");
					break;
				case "toggleLabels":
					if (this.map.getLayer('bunkerLabels')) {
						this.toggleLayers("bunkerLabels", "toggleLabels");
					}
					break;
				case "opacityAllNotIT":
					this.map.setPaintProperty('country-boundaries', 'fill-opacity', this.state.guiData.opacityAllNotIT);
					break;
				case "opacityITnotST":
					this.map.setPaintProperty('zmask', 'fill-opacity', this.state.guiData.opacityITnotST);
					this.map.setPaintProperty('choropleth-fill', 'fill-opacity', this.state.guiData.opacityITnotST);
					break;
				case "opacitySperren":
					this.map.setPaintProperty('msmuc-7ay4yckz', 'raster-opacity', this.state.guiData.opacitySperren);
					break;
				case "opacityVallo":
					this.map.setPaintProperty('msmuc-5f8eyat9', 'raster-opacity', this.state.guiData.opacityVallo);
					break;
				case "opacitySatellite":
					this.map.setPaintProperty('satellite', 'raster-opacity', this.state.guiData.opacitySatellite);
					break;
				default:
					break;
			}
			return;
		});
	}


	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return true
//    if (this.state.init === true) { return true } else return false;
	}

	componentDidMount() {

	const zeroPad = (num, places) => String(num).padStart(places, '0')

	logVersion('valloAlpino')

	const langsel = navigator.languages
			? navigator.languages[0]
			: (navigator.language || navigator.userLanguage)
//		console.log("lang ### ", langsel);
//		console.log("lang ### ", navigator.language);
//		console.log("lang ### ", navigator.languages[0]);
//		console.log("lang ### ", navigator.languages);

// default german
		useStore.setState({language: 'DE'})
		document.documentElement.lang = 'de'

/*
// default english
		if (langsel === 'de') {
//			console.log('de lang detected');
			useStore.setState({language: 'DE'})
			document.documentElement.lang = 'de'
		}
		else if (langsel === 'it') {
//			console.log('it lang detected');
			useStore.setState({language: 'IT'})
			document.documentElement.lang = 'it'
		}
		else {
//			console.log('en lang detected');
			useStore.setState({language: 'EN'})
			document.documentElement.lang = 'en'
		}
 */

		this.loadData(1);

		// check editorkey
		try {
			let parsed = qs.parse(window.location.search);
			var stripped = parsed.editortoken.replace(/[^A-Za-z0-9]/g, ''); // sanitize, only alphanumeric characters allowed
			if (stripped === parsed.editortoken) {
				this.getAuth(stripped);
//				this.setState({queryParams: parsed});
			}
		} catch (e) {
//			console.log("no editor");
		}

		// check debug mode
		let parsed = qs.parse(window.location.search);
//		setQuery({queryParams: parsed});

		if (parsed.debug && parseInt(parsed.debug) > -1 && parseInt(parsed.debug) < 2) {
//			console.log("debug level: ", parsed.debug);
			if (parseInt(parsed.debug) === 1) {
				this.setState({debugLevel: 1})
//				setDebugLevel(1);
			}
		}

		if (parsed.c ) {
			let coords = parsed.c.split( ',')
			if (coords.length === 2 &&
				parseInt(coords[0]) > 5 && parseInt(coords[0]) < 50 &&
				parseInt(coords[1]) > 5 && parseInt(coords[1]) < 50
			) {
				this.setState({lat: parseFloat(coords[0])})
				this.setState({lng: parseFloat(coords[1])})
			}
		}

		if (parsed.zoom && parseInt(parsed.zoom) >= 1 && parseInt(parsed.zoom) <= 20) {
			this.setState({zoom: parseInt(parsed.zoom)})
		}

		if (parsed.b && parseInt(parsed.b) >= -360 && parseInt(parsed.b) <= 360) {
						this.setState({bearing: parseInt(parsed.b)})
				}

		if (parsed.p && parseInt(parsed.p) > 0 && parseInt(parsed.p) <= 85) {
			this.setState({pitch: parseInt(parsed.p)})
		}

		const imagesPreload = [
			"images/STATION-1-FOTO-1.jpg",
		];
		imagesPreload.forEach((image) => {
			const newImage = new Image();
			newImage.src = image;
			window[image] = newImage;
		});
	}

	componentDidUpdate(prevProps, prevState) {

//		console.log("%c ---> App: state updated", "color: blue", this.state);
//		console.log("%c ---> App: prevState", "color: blue", prevState);

//		if (this.state.lang !== prevState.lang) {
//			console.log("FORCE UPDATE");
//			this.forceUpdate();
//		}

		if (this.state.limitExceeded === true) return console.log("LIMIT EXCEEDED");

		if (this.state.editorAuthorized !== prevState.editorAuthorized && this.state.editorAuthorized === true) {

			this.setState({initDraw: true})
			this.setState({debugLevel:1})
//			this.Draw = new MapboxDraw();
//			this.map.addControl(this.Draw, 'top-left');
		}

		if (prevState.currData !== this.state.currData) {

			if (this.state.currData !== "monthly limit exceeded") {

				///////////////////////////
				//   L O A D    M A P    //
				///////////////////////////

				const maxbounds = [5, 40, 17, 50]; // wsen

				this.map = new mapboxgl.Map({
					container: this.mapContainer,
//				    style: 'mapbox://styles/msmuc/ckkptj4ro0e9a17mmtbqyr270?optimize=true',
					style: 'mapbox://styles/msmuc/ckkptj4ro0e9a17mmtbqyr270',
					center: [this.state.lng, this.state.lat],
					maxBounds: maxbounds,
					pitch: this.state.pitch, // pitch in degrees
					bearing: this.state.bearing, // bearing in degrees
					zoom: this.state.zoom,
					optimizeForTerrain: true
				});

				this.setState({map: this.map});

				this.map.addControl(new mapboxgl.NavigationControl({
					visualizePitch: true,
					showZoom: true,
					showCompass: true
				}), 'top-left');

				this.map.addControl(new mapboxgl.FullscreenControl());


				// add scale control
				const scale = new mapboxgl.ScaleControl({
					maxWidth: 100,
					unit: 'metric'
				});
				this.map.addControl(scale);

				scale.setUnit('metric');



				// check if loading is complete, remove splash screen
				this.map.once('idle', (e) => {
//                  this.map.showCollisionBoxes = true;
					this.setState({
						hideSplash: true
					})

					if (this.state.initDraw === true) {
						d3.selectAll(".bunkerSVGs").style("visibility", 'hidden');
						d3.selectAll(".button").style("visibility", 'visible');
						this.map.setLayoutProperty('bunker-poly', 'visibility', 'none');
					}

				});

				// on load
				this.map.once('load', () => {

//					this.map.setFog({
//						'range': [2, 12],
//						'color': 'white',
//						'horizon-blend': 0.1
//					});

					// .... stuff moved to the layer component
					// ...
					// ...
					// set maps state if finished
					this.setState({
						mapLoaded: true
					});

				});

			} else {
				// limit exceeded
				this.setState({limitExceeded: true});
			}
		}

		const currState = this.state;

//    let diff = getObjectDiff(this.state, prevState);
//    console.log(diff);

		// load SVGs
		if (prevState.mapLoaded !== this.state.mapLoaded && this.state.mapLoaded === true) {

			this.loadSVG('bunker-svg', mySVG)
				.then(svg1 => this.loadSVG('bunker2-svg', mySVG2, 25, 14))
				.then(svglo => this.setState({SVGLoaded: true}));

		}

		if (prevState.SVGLoaded !== this.state.SVGLoaded && this.state.SVGLoaded === true) {
			// console.log("state SVGloaded:",this.state.SVGLoaded);

			this.map.addLayer({
				"id": "bunker-SVG",
				"type": "symbol",
				"source": "bunker",
				"layout": {
					"icon-image": 'bunker-svg',
//					"icon-allow-overlap": true,
					"icon-ignore-placement": true,
					"icon-size": {stops: [[3, 0.1], [8, 0.3], [11, 0.5], [16, 0.8]]}
				}
			});

			this.map.addLayer({
				"id": "bunker-SVG2",
				"type": "symbol",
				"source": "point",
				"layout": {
					"icon-image": 'bunker2-svg',
//					"icon-allow-overlap": true,
					"icon-ignore-placement": true,
					"icon-size": 0.5
				}
			});
		}

		// is everything loaded now?
		if (currState.bunkerLoaded === true && currState.SVGLoaded === true && currState.mapLoaded === true && currState.allLoaded === false) {
			//console.log("%c ---> App: everything loaded = ", "color: orangered");
			this.setState({allLoaded: true})
		}

		// everything is loaded, init datGUI now
		if (prevState.allLoaded !== this.state.allLoaded && this.state.allLoaded === true) {

			if (prevState.init === null) {
				//console.log("%c ---> App: init with datGUI now", "color: orangered");

				// call init datGUI with empty array
				let emptyGUI = {};
				this.setAllGuiData(emptyGUI);
				this.setState({init: true});
			}
		}

		if (this.state.guiData !== prevState.guiData) {
			//console.log("starting GUI Data update");
			// set changes in datGUI
			if (this.state.init === true) {
				this.setAllGuiData(prevState.guiData);
			}
		}

		if (this.state.init === true && this.state.activateSidebars === false) {
//			console.log(" S I D E B A R S   A C T I V A T E D ");
			this.setState({activateSidebars: true});
		}

		if (this.state.init === true && this.state.lastGuiButton === "drawData") {
			if (typeof this.draw !== undefined) {
				console.log("draw data", this.draw.getAll());
				alert(JSON.stringify(this.draw.getAll(), null, 4));
				this.setState({lastGuiButton: null});
			}
		}

		if (this.state.init === true && this.state.storyRemoteAction === "needs update") {
			//console.log("Remote Action");
			this.setState({storyRemoteAction: "next"})
		}

		if (this.state.init === true && this.state.lastGuiButton === "Quicktour") {

			// console.log("::: last GUIButton :::");
			// start storytelling component
			var guiData = {...this.state.guiData};
			guiData.toggleBunkersD3 = false;
			guiData.toggleBunkersSVG = true;
			guiData.toggleBunkersCircleAll = false;
			guiData.toggleBunkersCircle = false;
			guiData.toggleBunkersPoly = false;
			guiData.toggleLabel = false;
//			guiData.toggleBunkersRadius = true;
//			guiData.collapseGUI = true;
			guiData.randomUpdate = Math.random(); // ! important ! to signal that app updates datGUI
			this.setState({
				startQuickTour: this.state.startQuickTour ? false : true,
				guiData
			});
			this.setState({showTimeline: false});
			this.setState({showLegend: false});
			this.setState({lastGuiButton: null});
		}

		if (this.state.init === true && this.state.story && this.state.story.storyData.status === "finished") {

			// console.log("::: finished1 :::");
			var guiData = {...this.state.guiData};
			guiData.toggleBunkersD3 = false;
			guiData.toggleBunkersSVG = false;
			guiData.toggleBunkersCircleAll = true;
			guiData.toggleBunkersCircle = true;
			guiData.toggleBunkersPoly = false;
			guiData.collapseGUI = false;
			guiData.toggleLabel = true;

			this.setState ({
				story: null,
				startQuickTour: false,
				guiData
			})
			this.setState({lastGuiButton: "finished"});

			this.setState({storyRemoteAction: "end"});
			this.setState({showLegend: true});
			this.setState({sidebarsAction: "close left"});

			this.setState({showTimeline: useStore.getState().builtprogress === 1 ? true : false });
			const next = useStore.getState().setRemoteAction('end')

		}

		if (this.state.init === true && this.state.story && this.state.lastGuiButton === "finished") {
			// console.log("::::::::::: finished2 :::::::::");

			var guiData = {...this.state.guiData};
			guiData.toggleBunkersD3 = false;
			guiData.toggleBunkersSVG = false;
			guiData.toggleBunkersCircleAll = true;
			guiData.toggleBunkersCircle = true;
			guiData.toggleBunkersPoly = false;
			guiData.collapseGUI = false;
			guiData.toggleLabel = true;

			this.setState ({
				startQuickTour: false,
				story: null,
				guiData
			})

			this.setState({storyRemoteAction: "end"});
			this.setState({showLegend: true});
			this.setState({sidebarsAction: "close left"});

			this.setState({showTimeline: useStore.getState().builtprogress === 1 ? true : false });
			const next = useStore.getState().setRemoteAction('end')
		}
	}

	render() {

		return (
			<div>
				{this.state.limitExceeded &&
				<div className="error" style={{width: '80%'}}>
					<h1>Sorry, service not available, connection limit exceeded for this month!</h1>
					<h1>Sorry, der Dienst ist momentan nicht verfügbar, das Limit wurde für dieses Monat überschritten!</h1>
					<h1>Siamo spiacenti, servizio non disponibile, limite di connessione superato per questo mese!</h1>
				</div>
				}
				{!this.state.hideSplash &&
				<div className='splashScreen'>
					<div className='loaderContainer'>
						<div className="loader">Loading...</div>
					</div>
				</div>
				}
				<div ref={el => this.mapContainer = el} className='mapContainer'/>
				{/*<D3Comp*/}
				{/*	states={this.state}*/}
				{/*/>*/}
				<BasicLayer
					states={this.state}
					debug={this.state.debugLevel}
				/>
				<Bunkers
					states={this.state}
					bunkerCallback={this.callbackHandler}
				/>
				{/*<div style={{visibility: 'hidden'}}>*/}

				<ReactDatGui
					guiData={this.state.guiData}
					debug={this.state.debugLevel}
					dataCallback={this.callbackData}
					dataCallbackButton={this.callbackDataButton}
				/>
				{/*</div>*/}

				{!this.state.initDraw &&
				<div className='transparent-bottom'/>
				}
				{!this.state.initDraw && this.state.showTimeline &&
				<TimeSlider
					map={this.state.map}
					bunkerLoaded={this.state.bunkerLoaded}
					bunkerDynamic={this.state.bunkerDynamic}
					sliderCallback={this.callbackHandler}
				/>
				}
{/*				{!this.state.initDraw &&*/}
{/*				<BarChart*/}
{/*//					map={this.state.map}*/}
{/*				/>*/}
{/*				}*/}

				{/*<div style={{position: 'absolute', top: 100, left: 100}}>{t('hello')}</div>*/}
				{/*<div style={{position: 'absolute', top: 130, left: 100}}> <Trans t={'hello'}/></div>*/}
				{/*<div style={{position: 'absolute', top: 150, left: 100}}> <Trans t={'hi'}/></div>*/}
				{/*<div style={{position: 'absolute', top: 170, left: 100}}> <Trans t={'ho ho ho'}/></div>*/}

				{!this.state.initDraw && this.state.bunkerLoaded &&
					<LegendAndControl
						map={this.state.map}
						bunkerLoaded={this.state.bunkerLoaded}
						showLegend={this.state.showLegend}
						legendCallback={this.callbackLegendHandler}
						legendProgressCallback={this.callbackLegendProgressHandler}
						changed={this.state.guiData}
						quicktourState={this.state.lastGuiButton}
						satSliderCallback={this.callbackSatSlider}
						langCallback={this.callbackLang}
					/>
				}
					{!this.state.initDraw && this.state.storyOn &&
				<Story
					guiData={this.state.guiData}
					lang={this.state.language}
					map={this.state.map}
					startStory={this.state.startQuickTour}
					storyCallback={this.callbackStoryHandler}
					storyRemoteAction={this.state.storyRemoteAction}
					storyRemoteCallback={this.callbackStoryRemote}
				/>
				}
				{!this.state.initDraw && this.state.storyOn &&
				<Sidebars
					map={this.state.map}
					lang={this.state.lang}
					leftSidebarsContent={this.state.sidebarsContent}
					sidebarsAction={this.state.sidebarsAction}
					activateSidebars={this.state.activateSidebars}
					sidebarsCallback={this.callbackSidebarsHandler}
					storyRemoteAction={this.state.storyRemoteAction}
					storyRemoteCallback={this.callbackStoryRemote}
				/>
				}

				{this.state.initDraw &&
				<Draw
					states={this.state}
					editorKey={this.state.editorKey}
					map={this.state.map}
					initDraw={this.state.initDraw}
					init={this.state.init}
				/>
				}

				{/*<div>*/}
				{/*	<div className={'navlink'} style={{position: 'fixed', top: '40px', left: '40vw', width: '80px'}}>*/}
				{/*		<svg x="0px" y="0px" viewBox="0 0 200 200">*/}
				{/*			<g>*/}
				{/*				<g transform="translate(0.000000, 100.000000) scale(0.00600000,-0.00600000)">*/}
				{/*					<path fill="#333333"*/}
				{/*					      d="M2396.9,4983.5c-51.7-24.9-339.1-300.8-866-827.7c-676.3-680.2-791.3-804.7-812.4-873.7c-51.7-178.2-90-130.3,1157.3-1379.5C3124.9,655.3,3079,693.6,3253.3,745.3c65.1,19.2,137.9,80.5,360.2,300.8l279.7,275.9l160.9-162.9L4217,996.3l-283.6-283.6l-283.6-283.6l72.8-24.9c457.9-164.8,917.8-505.8,1210.9-900.5c107.3-143.7,291.2-494.3,348.7-659.1l24.9-72.8l356.4,356.4l354.5,354.5l162.9-162.9L6341.9-843l-346.8-348.7c-283.6-287.4-350.6-365.9-371.7-431.1c-51.7-178.2-90-130.3,1157.2-1379.5c1247.3-1247.3,1201.3-1209,1379.5-1157.2c69,21.1,191.6,136,889,831.5c695.5,697.4,810.4,820,831.5,890.9c51.7,176.3,90,130.3-1157.2,1377.6C7474.2,187.8,7520.2,149.5,7345.8,97.7c-65.1-19.2-138-80.5-360.2-300.8L6705.9-479L6545-316.1l-160.9,161l153.3,159c82.4,88.1,180.1,201.2,214.6,254.8c101.5,153.3,139.9,335.3,101.5,469.4c-11.5,40.2,0,63.2,69,139.9c298.9,323.8,275.9,839.2-51.7,1151.5c-132.2,126.5-274,197.4-450.3,226.1c-239.5,40.2-528.8-49.8-685.9-210.8c-70.9-72.8-78.6-74.7-143.7-57.5c-103.5,28.7-245.2,5.7-383.2-63.2c-92-44.1-187.8-122.6-375.5-306.6l-252.9-245.2l-160.9,160.9l-160.9,162.9l346.8,348.7c283.6,287.4,350.6,365.9,371.7,433c51.7,174.4,88.1,130.3-1138.1,1362.3c-756.8,756.8-1140,1128.5-1191.7,1153.4C2550.1,5027.5,2492.7,5027.5,2396.9,4983.5z M2747.5,4056.2l214.6-214.6l-216.5-216.5L2531,3410.5l-220.3,220.3l-220.3,220.3l210.8,210.8c115,115,214.6,210.8,220.3,210.8S2628.7,4174.9,2747.5,4056.2z M2096,3404.7l214.6-214.6l-216.5-216.5L1879.5,2759l-220.3,220.3l-220.3,220.3l210.8,210.8c115,115,214.6,210.8,220.3,210.8C1875.7,3621.2,1977.3,3523.5,2096,3404.7z M3393.2,3410.5l210.8-210.8l-216.5-216.5l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8S3278.2,3525.4,3393.2,3410.5z M4038.9,2333.7l-214.6-216.5l-220.3,220.3l-220.3,220.3l214.6,214.6l216.5,216.5l220.3-220.3l220.3-220.3L4038.9,2333.7z M2741.7,2759l210.8-210.8L2736,2331.8l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8S2626.8,2874,2741.7,2759z M3389.3,1682.2l-216.5-216.5l-210.8,210.8c-115,115-210.8,218.4-210.8,229.9c0,9.6,92,111.1,205,224.2l206.9,206.9l220.3-220.3l220.3-220.3L3389.3,1682.2z M7652.4-848.8l214.6-214.6l-216.5-216.5l-214.6-214.6l-220.3,220.3l-220.3,220.3L7206-843c115,115,214.6,210.8,220.3,210.8C7432.1-632.3,7533.6-730,7652.4-848.8z M6999.1-1498.3l216.5-216.5l-205-205c-113-115-214.6-206.9-226.1-206.9c-11.5,0-115,95.8-229.9,210.8l-210.8,210.8l210.8,210.8c115,116.9,214.6,210.8,220.3,210.8C6778.7-1283.7,6880.3-1381.4,6999.1-1498.3z M8298.1-1494.5l210.8-210.8l-216.5-216.5l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8C8083.5-1283.7,8183.1-1379.5,8298.1-1494.5z M8943.8-2571.3l-214.6-216.5l-220.3,220.3l-220.3,220.3l214.6,214.6l216.5,216.5l220.3-220.3l220.3-220.3L8943.8-2571.3z M7646.7-2145.9l210.8-210.8l-216.5-216.5l-214.6-214.6l-214.6,214.6l-216.5,216.5l210.8,210.8c115,115,214.6,210.8,220.3,210.8C7432.1-1935.1,7531.7-2030.9,7646.7-2145.9z M8292.4-3222.7l-214.6-216.5l-220.3,220.3l-220.3,220.3l214.6,214.6l216.5,216.5l220.3-220.3l220.3-220.3L8292.4-3222.7z"/>*/}
				{/*					<path fill="#333333"*/}
				{/*					      d="M2038.6,392.8c-300.8-47.9-603.5-199.3-682.1-343c-53.7-99.6-42.2-312.3,30.6-526.9c109.2-318.1,337.2-730,603.5-1088.3l116.9-159l111.1,197.3c59.4,107.3,109.2,205,111.1,214.6c0,11.5-42.2,70.9-92,134.1c-235.7,293.1-406.2,580.5-406.2,680.2c0,172.4,308.5,93.9,741.5-189.7c551.8-360.2,1228.1-1030.8,1596-1582.6c291.2-433,385.1-776,214.6-776c-90.1,0-302.7,118.8-563.3,316.1c-134.1,99.6-249.1,182-254.8,182c-13.4,0-325.7-182-367.9-216.5c-30.6-23,24.9-69,327.6-272.1c622.7-413.8,1189.8-607.4,1410.2-479c90.1,53.6,214.6,247.2,274,425.4c208.8,636.1,17.2,1550-471.3,2241.7c-149.5,210.8-454.1,521.2-661,672.5C3462.1,275.9,2686.2,492.4,2038.6,392.8z"/>*/}
				{/*					<path fill="#333333"*/}
				{/*					      d="M2860.5-1517.5c-26.8-34.5-157.1-249.1-291.2-475.2s-247.2-415.8-251-419.6c-3.8-3.8-19.2,1.9-32.6,13.4c-13.4,11.5-70.9,30.7-126.5,44.1c-277.8,59.4-526.9-151.4-526.9-442.6c0-264.4,185.8-448.3,448.3-448.3c316.1,0,521.2,289.3,421.5,592c-13.4,38.3-19.2,72.8-15.3,76.6c1.9,1.9,199.3,128.4,436.8,277.8c237.6,149.4,446.4,285.5,465.6,302.7c76.6,67.1,21.1,226.1-134.1,383.2C3086.6-1444.6,2941-1408.3,2860.5-1517.5z"/>*/}
				{/*					<path*/}
				{/*						d="M850.7-2663.2c-70.9-42.1-105.4-459.8-55.6-670.6c101.6-425.4,431.1-714.7,873.7-764.5c149.4-17.2,408.1,3.8,492.4,38.3c67.1,26.8,90,101.6,51.7,168.6c-26.8,47.9-38.3,49.8-237.6,61.3c-243.3,13.4-385.1,55.6-544.1,164.8c-249.1,172.4-385.1,450.3-385.1,795.1c0,149.4-3.8,168.6-42.2,195.4C956-2640.2,898.6-2636.4,850.7-2663.2z"/>*/}
				{/*					<path fill="#333333"*/}
				{/*					      d="M168.6-2715c-72.8-139.9-92-680.2-36.4-913.9c113.1-457.9,367.9-793.2,749.2-979.1c270.2-134.1,427.3-168.6,758.7-168.6c208.8,1.9,310.4,9.6,411.9,36.4l134.1,36.4l5.7,90.1c7.7,128.4-32.6,151.3-226.1,128.4c-162.9-19.2-413.9,3.8-574.8,51.7c-358.3,105.4-666.8,362.1-843,701.3c-122.6,233.8-157.1,396.6-157.1,724.2c0,162.9-7.7,287.4-19.2,302.7C341-2669,189.6-2676.6,168.6-2715z"/>*/}
				{/*				</g>*/}
				{/*			</g>*/}
				{/*		</svg>*/}
				{/*	</div>*/}
				{/*	<div className={'navlink'} style={{position: 'fixed', top: '75px', left: '43vw'}}>*/}

				{/*		<SatSlider*/}
				{/*			satSliderCallback={this.callbackSatSlider}*/}
				{/*		>*/}
				{/*		</SatSlider>*/}
				{/*	</div>*/}
				{/*</div>*/}


				{/*<div className='testoverlay'>*/}
				{/*	<ShowVar/>*/}
				{/*	<AddVar/>*/}
				{/*</div>*/}

			</div>
		)
	}
}

ReactDOM.render(
	<App/>,
	document.getElementById('root')
);
export default App
